import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiLock, FiPhone, FiArrowLeft } from "react-icons/fi";
import styles from "./Login.module.css";
import api from "../services/axiosConfig";
import { LOGIN } from "../constant-value";


const Login = () => {
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const res = await api.post(LOGIN, {
        userName,
        password,
      });

      if (res.data.isSuccess) {
        navigate("/");
      } else {
        navigate("/login");
        setMessage(res.data.message);
      }
    } catch (error) {
      console.log("error");

      // خطاها به صورت خودکار توسط interceptor مدیریت می‌شوند
      setMessage(
        error.response?.data?.message || "خطا در ارتباط با سرور"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className={styles.page} dir="rtl">
      <div className={styles.backgroundGlow} />

      <section className={styles.loginWrapper}>
        <div className={styles.loginCard}>
          {/* Header */}
          <div className={styles.header}>
            <div className={styles.logo}>
              <span className={styles.logoInner}>
                 <img src="/logo.png" alt="logo" />
              </span>
            </div>

            <h1>خوش آمدید</h1>

            <p>
              برای ادامه وارد حساب کاربری خود شوید
            </p>
          </div>

          {/* Form */}
          <form
            onSubmit={handleLogin}
            className={styles.form}
          >
            {/* Phone */}
            <div className={styles.field}>
              <label htmlFor="phone">
                شماره همراه
              </label>

              <div className={styles.inputWrapper}>
                <FiPhone className={styles.inputIcon} />

                <input
                  id="phone"
                  type="tel"
                  value={userName}
                  onChange={(e) =>
                    setUsername(e.target.value)
                  }
                  placeholder="09xxxxxxxxx"
                  required
                  autoComplete="tel"
                  inputMode="tel"
                  disabled={isLoading}
                />
              </div>
            </div>

            {/* Password */}
            <div className={styles.field}>
              <div className={styles.passwordHeader}>
                <label htmlFor="password">
                  رمز عبور
                </label>

                <Link to="/forgot">
                  فراموشی رمز عبور؟
                </Link>
              </div>

              <div className={styles.inputWrapper}>
                <FiLock className={styles.inputIcon} />

                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) =>
                    setPassword(e.target.value)
                  }
                  placeholder="رمز عبور خود را وارد کنید"
                  required
                  autoComplete="current-password"
                  disabled={isLoading}
                />
              </div>
            </div>

            {/* Message */}
            {message && (
              <div
                className={`${styles.message} ${
                  message.includes("موفق")
                    ? styles.success
                    : styles.error
                }`}
              >
                {message}
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              className={styles.submitButton}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className={styles.spinner} />
                  <span>در حال ورود...</span>
                </>
              ) : (
                <>
                  <span>ورود به حساب</span>
                  <FiArrowLeft />
                </>
              )}
            </button>
          </form>

          {/* Register */}
          <div className={styles.register}>
            <span>حساب کاربری ندارید؟</span>

            <Link to="/register">
              ثبت نام کنید
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Login;